<script>
import {mapActions, mapGetters} from 'vuex'
import {PRODUCT_EXPERIENCE} from '../../types/products'
import {SERVER_DATE_FORMAT} from '../../utils/formatter'
import {EMPTY_FLIGHTS_HOTELS_CHECK, EMPTY_FLIGHTS_CHECK, EMPTY_HOTELS_CHECK} from '../../utils/messages'
import SearchExperienceAction from '../actions/SearchExperienceAction'
import response from '../../fake/experience-response'
import {FAKE_ACTIVE} from '../../utils/config'

export default {
  name: 'ExperienceSearcher',
  mixins: [SearchExperienceAction],
  computed: {
    response () {
      return response
    }
  },
  methods: {
    ...mapActions(['addTour', 'loadingStart', 'loadingEnd', 'addSearch', 'modifyExperience', 'loadFlights', 'loadFlexibleDates', 'loadHotels', 'loadServizi', 'loadTrasferimenti', 'addReplaceServizio']),
    ...mapGetters(['getTourList']),
    searchExperienceDetail (data) {
      return FAKE_ACTIVE ? this.searchFake(data) : this.searchReal(data)
    },
    searchFake (data) {
      this.initSearch(data)
      this.loadingFakeData()
      this.selectServizi(data.experience)
      this.$router.push('/experience')
      this.$scrollTo('#app')
    },
    loadingFakeData () {
      this.loadFlights(this.response.object.flightVectorGroups)
      this.loadFlexibleDates(this.response.object.periodFlights)
      this.loadHotels(this.response.object.periodHotels)
      this.loadServizi(this.response.object.periodServizi)
      this.loadTrasferimenti(this.response.object.periodServizi)
      const {tours} = this.response.object
      if (tours && tours.length > 0) {
        const {tourDetailResponses} = tours[0].actionResultObject.object
        const anagrafica = this.getTourList().find(item => {
          return item.element.productID === tourDetailResponses[0].detail.productID
        })
        const tourResult = {detailResponses: tourDetailResponses, anagrafica, date: tours[0].date.date}
        this.addTour(tourResult)
      }
    },
    initSearch (data) {
      const experience = data.experience
      const partenza = data.partenza
      this.modifyExperience(experience)
      this.addSearch({product: PRODUCT_EXPERIENCE, aereoporto: this.search.aereoporto, camere: this.search.camere, partenza, isGiornoSuccessivoObbligatorio: this.$store.getters.isGiornoSuccessivoObbligatorio})
    },
    searchReal (data) {
      this.initSearch(data)
      const experience = data.experience
      const andata = data.partenza
      const delta = this.$store.getters.isGiornoSuccessivoObbligatorio ? 0 : 1
      const ritorno = this.$moment(andata).add(experience.days.length - delta, 'days')
      const searchData = {
        product: PRODUCT_EXPERIENCE,
        aereoporto: this.search.aereoporto,
        andata: this.$moment(andata).format(SERVER_DATE_FORMAT),
        ritorno: this.$moment(ritorno).format(SERVER_DATE_FORMAT),
        camere: this.search.camere
      }
      const payload = {searchData, experience}
      this.searchExperience(payload).then((response) => {
        // const {tours, flightVectorGroups, periodHotels, servizi, flightDepartureInfo} = response.data.object
        const {tours, flightVectorGroups, periodHotels, servizi} = response.data.object
        // asserts & messages
        const emptyFlight = !flightVectorGroups || flightVectorGroups.length === 0
        const emptyHotel = !periodHotels || periodHotels.length === 0
        if (emptyFlight && emptyHotel) {
          this.resultMessage = EMPTY_FLIGHTS_HOTELS_CHECK
          return
        } else if (emptyFlight) {
          this.resultMessage = EMPTY_FLIGHTS_CHECK
          return
        } else if (emptyHotel) {
          this.resultMessage = EMPTY_HOTELS_CHECK
          return
        }
        if (flightVectorGroups) {
          this.loadFlights(flightVectorGroups)
        } else {
          this.$toastr.error(EMPTY_FLIGHTS_CHECK)
          return
        }
        // if (flightDepartureInfo) this.loadFlightDepartureInfo({...flightDepartureInfo, dateSelected: andata})
        if (periodHotels && periodHotels.length > 0) {
          this.loadHotels(periodHotels)
        } else {
          this.$toastr.error(EMPTY_HOTELS_CHECK)
          return
        }
        if (servizi) {
          this.loadServizi(servizi)
          this.loadTrasferimenti(servizi)
          this.selectServizi(experience)
        }
        // TODO: attenzione impostare l'anagrafica estrarla dal tourDetailResponses
        // in questo modo manteniamo la stessa struttura dati utilizzata per il tour
        // un tour al massimo per experience
        if (tours && tours.length > 0) {
          const actionResultObject = tours[0].actionResultObject
          if (actionResultObject.done === false) {
            this.$toastr.error(actionResultObject.messages[0].message)
            return
          }
          const {tourDetailResponses, date} = actionResultObject.object
          const anagrafica = this.getTourList().find(item => {
            return item.element.productID === tourDetailResponses[0].detail.productID
          })
          const tourResult = {detailResponses: tourDetailResponses, anagrafica, date: date}
          this.addTour(tourResult)
        }
        this.$router.push('/experience')
      }).finally(() => {
        this.$scrollTo('#app')
      })
    },
    selectServizi (experience) {
      const list = this.prepareServizi(experience)
      const itinerario = this.getItinerario()
      list.forEach(item => {
        const servicesTrasferimenti = itinerario.services.list.concat(itinerario.trasferimenti.list)
        const elem = servicesTrasferimenti.find(service => {
          return item.code === service.detail.productID
        })
        if (elem && item.day < itinerario.days.length) {
          const dateSelected = itinerario.days[item.day].day
          const groups = this.getSearch().camere.map((item, index) => {
            return {...item, dateSelected, selected: true, id: index + 1}
          })
          const payload = {...elem, groups, isTrasferimento: item.isTrasferimento === true, isObbligatorio: item.isObbligatorio === true, isAndata: item.isTrasferimento && item.day === 0}
          this.addReplaceServizio(payload)
        }
      })
    },
    prepareServizi (experience) {
      let list = []
      experience.days.forEach((day, index) => {
        if (day.list) {
          const results = day.list.map((item) => {
            return {code: item.codiceServizio, day: index, isObbligatorio: item.isObbligatorio, isTrasferimento: item.isTrasferimento === true}
          })
          list = list.concat(results)
        }
      })
      return list
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/searcher/ExperienceSearcher.vue